import { gql } from 'react-apollo';

export default gql`
  mutation commentLike($commentId: ID!) {
    commentLike(commentId: $commentId) {
      content
      title
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/commentLike.js